// fe/src/utils/analytics.js
/**
 * Analytics wrapper — GA4 (gtag.js) + Facebook Pixel (fbq).
 * Injects both SDKs at runtime (mirrors utils/facebook.js). Every function
 * is guarded and no-ops when the relevant channel is disabled or not yet loaded.
 */
import { GA4_MEASUREMENT_ID, FB_PIXEL_ID, isGaEnabled, isPixelEnabled } from '../config/analytics';
import { getUtmParams } from './utm';

let initialized = false;

const initGa = () => {
  if (window.gtag || document.getElementById('ga4-js')) return;
  const s = document.createElement('script');
  s.id = 'ga4-js';
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  // send_page_view:false — usePageTracking fires the first page_view itself
  window.gtag('config', GA4_MEASUREMENT_ID, { send_page_view: false });
};

const initPixel = () => {
  if (window.fbq) return;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', FB_PIXEL_ID);
};

export const initAnalytics = () => {
  if (initialized) return;
  initialized = true;
  try {
    if (isGaEnabled()) initGa();
    if (isPixelEnabled()) initPixel();
  } catch {
    // best-effort; never break the app
  }
};

export const trackPageView = (path) => {
  initAnalytics();
  try {
    if (isGaEnabled() && window.gtag) {
      window.gtag('event', 'page_view', { page_path: path, ...getUtmParams() });
    }
    if (isPixelEnabled() && window.fbq) window.fbq('track', 'PageView', getUtmParams());
  } catch { /* noop */ }
};

export const trackEvent = (name, params = {}) => {
  initAnalytics();
  try {
    const payload = { ...getUtmParams(), ...params };
    if (isGaEnabled() && window.gtag) window.gtag('event', name, payload);
    if (isPixelEnabled() && window.fbq) window.fbq('trackCustom', name, payload);
  } catch { /* noop */ }
};

export const trackSignUp = (method) => {
  initAnalytics();
  const payload = { method, ...getUtmParams() };
  try {
    if (isGaEnabled() && window.gtag) window.gtag('event', 'sign_up', payload);
    if (isPixelEnabled() && window.fbq) window.fbq('track', 'CompleteRegistration', payload);
  } catch { /* noop */ }
};

export const trackFeatureUse = (featureCode, params = {}) => {
  trackEvent('feature_use', { feature: featureCode, ...params });
};
